module.exports = __webpack_public_path__ + "img/close-icon.f5a8e652.svg";